import React from 'react';
import Link from 'next/link';
import { useLocaleLink } from '@/ui/hooks/useLocaleLink';
import { twMerge } from 'tailwind-merge';
import OptimizedImage from '../../../../shared/OptimizedImage';
import { ProductImageProps } from './types/CartProductImageProps';

function CartProductImage({
  productPath,
  productName,
  image,
  bundle,
  toggleCartDisplay,
  quantity,
  variant,
}: ProductImageProps) {
  const { localizedLink } = useLocaleLink();

  const getSizeClasses = () => {
    switch (variant?.imageSize) {
      case 'lg':
        return bundle ? 'h-25 w-25' : 'h-37 w-37';
      case 'responsive':
        return bundle ? 'h-16 w-16 lg:h-25 lg:w-25' : 'h-25 w-25 lg:h-37 lg:w-37';
      case 'md':
        return 'h-25 w-25';
      case 'sm':
      default:
        return bundle ? 'h-16 w-16' : 'h-25 w-25';
    }
  };

  const showBadge = variant?.showQuantityBadge && !!quantity && quantity > 1;

  return (
    <div
      className={twMerge(
        'relative z-0 flex-shrink-0 overflow-hidden rounded-lg border border-neutral-10 bg-white',
        getSizeClasses(),
      )}
    >
      {productPath ? (
        <Link
          href={localizedLink(productPath)}
          onClick={toggleCartDisplay}
          aria-label={productName || ''}
        >
          <OptimizedImage image={image} fill sizes="100px" className="object-contain py-2" />
        </Link>
      ) : (
        <OptimizedImage image={image} fill sizes="100px" className="object-contain py-2" />
      )}
      {showBadge && (
        <div className="absolute left-0 top-0 z-10 rounded-br-lg rounded-tl-lg bg-primary-100 px-2 font-bold">
          {quantity}
        </div>
      )}
    </div>
  );
}

export default CartProductImage;
